<template>
    <div
        id="astro"
    ></div>
</template>

<script>

import Vue from "vue";

import { astro } from "@/assets/js/astrochart.min.js";
import astroSetting from "@/assets/js/astroSetting.js";



export default {
    name: "AstroChart",
    props: {
        astroData: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            data1: {
                "planets":{"Jupiter":[216.3007406],"Mars":[228.0074908],"Mercury":[185.8633149],"Moon":[321.7418288],"NNode":[101.9302463],"Neptune":[264.2776812],"Pluto":[205.0715053],"Saturn":[199.7754195],"Sun":[159.2149463],"Uranus":[240.8160062],"Venus":[142.7343186]},
                "cusps":[108.0407009,120,150,198.0407009,210,240,288.0407009,300,330,18.04070089999999,30,60]	
            },
            chartData: this.astroData,
            window: {
                width: 0,
                height: 0
            },
        };
    },
    computed: {
        
    },
    watch: {
        astroData: function(){
            this.chartData = this.astroData;
            if(window.innerWidth <= 480)
            {
                if(this.chartData.transit !== false){
                    this.buildChart(340, 340, 0.5);
                }else{
                    this.buildChart(280, 280, 0.5);
                }
            }else{
                if(this.chartData.transit !== false){
                    this.buildChart(600, 600, 1);
                }else{
                    this.buildChart(540, 540, 1);
                }
            }
        },
    },
  
    mounted: function() {
        if(window.innerWidth <= 480)
        {
            if(this.chartData.transit !== false){
                this.buildChart(340, 340, 0.5);
            }else{
                this.buildChart(280, 280, 0.5);
            }
        }else{
            if(this.chartData.transit !== false){
                this.buildChart(600, 600, 1);
            }else{
                this.buildChart(540, 540, 1);
            }
        }
    },
    methods: {
        buildChart(width, height, symbolScal) {
            document.getElementById("astro").innerHTML = "";
            var mrgn = 0;
            if(this.chartData.transit !== false){
                mrgn = 60;
            }
            var astrology = window.astrology;
            // var radix = new astrology.Chart("astro", 480, 400, {MARGIN:0, COLOR_BACKGROUND: "#351c67", POINTS_COLOR: "#fff", CUSPS_FONT_COLOR: "#fff", LINE_COLOR: "#3C317F", CIRCLE_COLOR: "#3C317F", SYMBOL_AXIS_FONT_COLOR: "#fff"}).radix( this.chartData );
            var radix = new astrology.Chart("astro", width, height, {SYMBOL_SCALE: symbolScal, MARGIN: mrgn, COLOR_BACKGROUND: "#230854"}).radix(this.chartData.data);

            // var radix = new astrology.Chart("astro", width, height, this.astroSetting).radix( this.data1 );
            if(this.chartData.transit !== false){
                radix.transit( this.chartData.transit );
            }
            // transit.aspects();	
            // // // data, duration in seconds, isReverse, callback
            // transit.animate( this.chartData.animateData, 6, false, function(){
            //     console.log("Animation finished.");
            // });																																 																																																            													            	       

            // radix.addPointsOfInterest({"As":[this.chartData.cusps[0]], "Ic":[this.chartData.cusps[3]], "Ds":[this.chartData.cusps[6]], "Mc":[this.chartData.cusps[9]]});
            // radix.addPointsOfInterest({"As":[this.data1.cusps[0]], "Ic":[this.data1.cusps[3]], "Ds":[this.data1.cusps[6]], "Mc":[this.data1.cusps[9]]});
            // radix.aspects();
        },
       
    }
};

</script>